import React from 'react';
import { Trophy } from 'lucide-react';
import { type MatchDetail, MatchStatus, type Round } from '@iziping/common';
import './HeatBracketDisplay.css';
import MatchBracket from './MatchBracket';
import { formatPlayersForBracket } from '@iziping/common';

interface RoundBracketDisplayProps {
    round: Round;
    index: number;
}

const RoundBracketDisplay: React.FC<RoundBracketDisplayProps> = ({ round, index }) => {
    let winner = '';
    let displayWinner = false;
    if (round.number === 0 && round.matches[0].status === MatchStatus.FINISHED) {
        winner = formatPlayersForBracket(
            round.matches[0].opponents.filter((player) => player.qualified)[0].heatRegistration
        );
        displayWinner = true;
    }
    return (
        <>
            <ul className={'round round-' + (index + 1)}>
                {round.matches?.map((match: MatchDetail) => (
                    <MatchBracket key={match.id} match={match} />
                ))}
                <li className="spacer">&nbsp;</li>
            </ul>
            {displayWinner && (
                <ul className="round">
                    <li className="champion-card">
                        <Trophy size={16} strokeWidth={2.5} />
                        {winner}
                    </li>
                </ul>
            )}
        </>
    );
};

export default RoundBracketDisplay;
